<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider
                        name="instructor_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('teaching_staff')">
                            <staff-auto-complete
                                v-model="formData.instructor_id"
                                :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider
                        name="semester_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox
                                :validate-error="errors[0]"
                                v-model="formData.semester_id"
                                :setActive="true"
                            ></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider
                        name="amount"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('amount')">
                            <b-input-group>
                                <b-input-group-prepend is-text>$</b-input-group-prepend>
                                <b-form-input
                                    type="number"
                                    min="0"
                                    step=".01"
                                    v-check-min-max-value
                                    v-model="formData.amount"
                                ></b-form-input>
                            </b-input-group>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('comments')">
                        <ValidationProvider
                            name="explanation"
                            v-slot="{ valid, errors }"
                        >
                            <b-input-group class="mb-1">
                                <b-form-input
                                    v-model="formData.explanation"
                                    :state="errors[0] ? false : null"
                                />
                            </b-input-group>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                                class="mb-2"
                            />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('expertise_type')">
                        <ValidationProvider name="expertise_type" rules="required" v-slot="{ errors }">
                            <ParameterSelectbox code="expertise_types" v-model="formData.expertise_type" :state="errors[0] ? false : null"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center mt-2">
                <b-button
                    variant="primary"
                    @click="createForm"
                    :disabled="formLoading"
                >
                    {{ $t("save") }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";
// Services
import AdjunctPaymentService from "@/services/AdjunctPaymentService";
// Other
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        SemestersSelectbox,
    },
    data() {
        return {
            formData: {
                instructor_id: null,
                expertise_type:null,
                semester_id: null,
                amount: null,
                currency: 'USD',
                explanation: null,
            },
            formLoading: false,
        };
    },
    methods: {
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.formLoading = true;
                AdjunctPaymentService.store(this.formData)
                    .then((response) => {
                        this.$toast.success(
                            this.$t("api." + response.data.message)
                        );
                        this.$emit("createFormSuccess", true);
                    })
                    .catch((e) => {
                        this.showErrors(e, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false;
                    });
            }
        },
    },
};
</script>
